import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-7xl mx-auto p-6 text-gray-800 leading-relaxed">
      {/* Who we are */}
      <h3 className="text-3xl font-bold mb-2">Who we are</h3>
      <p className="mb-4 mt-8 text-black text-md">
        Our website address is: <strong>https://www.GURU.com</strong>
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        We value the trust you place in <strong>Guru Sports  – GURU</strong>.
        That's why we insist upon the highest standards for secure transactions
        and customer information privacy. Please read the following statement to
        learn about our information gathering and dissemination practices. By
        registering with <strong>GURU.com</strong>, you acknowledge your
        acceptance of the terms of this policy, your consent to provide required
        personal information and that any information provided by you through{" "}
        <strong>GURU.com</strong> is provided under a lawful contract.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        Note: Our privacy policy is subject to change at any time without
        notice. To make sure you are aware of any changes, please review this
        policy periodically.
      </p>

      <hr className="my-6 " />

      {/* Section 1 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        1. Collection of Personally Identifiable Information
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        We collect personally identifiable information (email address, name,
        phone number, etc.) from you when you set up a free account with{" "}
        <strong>GURU.com</strong>. While you can browse some sections of our
        site without being a registered member, certain activities (such as
        placing an order) do require registration.
      </p>

      {/* Section 2 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        2. Use of Demographic and Profile Data
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        We use personal information to provide the services you request. To the
        extent we use your personal information to market to you, we will
        provide you the ability to opt-out of such uses. We use your personal
        information to resolve disputes; troubleshoot problems; help promote a
        safe service; collect fees owed; measure consumer interest in our
        products and services; inform you about online and offline offers,
        products, services, and updates; customize your experience; detect and
        protect us against error, fraud and other criminal activity; enforce our
        terms and conditions; and as otherwise described to you at the time of
        collection.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        In our efforts to continually improve our product and service offerings,
        we collect and analyze demographic, profile and usage data about our
        user's activity on our website. We identify and use your IP address to
        help diagnose problems with our server, and to administer our website.
        Your IP address is also used to help identify you and to gather broad
        demographic information.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        We will occasionally ask you to complete optional online surveys. These
        surveys may ask you for contact information and demographic information
        (like zip code, age, etc). We use this data to tailor your experience at
        our site, providing you with content that we think you might be
        interested in and to display content according to your preferences.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        <strong>Cookies:</strong> A "cookie" is a small piece of information
        stored by a Web server on a Web browser so it can be later read back
        from that browser. Cookies are useful for enabling the browser to
        remember information specific to a given user. <strong>GURU.com</strong>{" "}
        places both permanent and temporary cookies in your computer's hard
        drive. <strong>Guru Sports </strong> cookies do not contain any of your
        personally identifiable information. You may choose to disable the
        cookies using the settings in your computer system. However, if you do
        so, you may not be able to use the full functionality of the site.
      </p>

      {/* Section 3 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        3. Sharing of Personal Information
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        We may share personal information with our other entities/agencies and
        affiliates to: help detect and prevent identity theft, fraud and other
        potentially illegal acts; correlate related or multiple accounts to
        prevent abuse of our services; and to facilitate joint or co-branded
        services that you request where such services are provided by more than
        one corporate entity or for analytical and IT services. Those entities
        and affiliates may not market to you as a result of such sharing unless
        you explicitly opt-in.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        We may disclose personal information if required to do so by law or in
        the good faith belief that such disclosure is reasonably necessary to
        respond to subpoenas, court orders, or other legal process. We may
        disclose personal information to law enforcement offices, third party
        rights owners, or others in the good faith belief that such disclosure
        is reasonably necessary to: enforce our Terms or Privacy Policy; respond
        to claims that an advertisement, posting or other content violates the
        rights of a third party; or protect the rights, property or personal
        safety of our users or the general public.
      </p>
      <p className="mb-4 mt-6 text-black text-md">
        <strong>Guru Sports </strong> and its affiliates will share some or all of
        your personal information with another business entity should we (or our
        assets) plan to merge with, or be acquired by that business entity.
        Should such a transaction occur, that other business entity (or the new
        combined entity) will be required to follow this privacy policy with
        respect to your personal information. Any third party with whom we share
        the information shall maintain reasonable level of confidentiality and
        data security as required under law.
      </p>

      {/* Section 4 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        4. Links to Other Sites
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Our site links to other websites that may collect personally
        identifiable information about you. <strong>GURU.com</strong> is not
        responsible for the privacy practices or the content of those linked
        websites.
      </p>

      {/* Section 5 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        5. Security Precautions
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Our site has stringent security measures in place to protect the loss,
        misuse, and alteration of the information under our control. Whenever
        you change or access your account information, we offer the use of a
        secure server. Once your information is in our possession we adhere to
        strict security guidelines in compliance with the Information Technology
        Act, 2000 (India) protecting it against unauthorized access.
      </p>

      {/* Section 6 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">6. Choice/Opt-Out</h3>
      <p className="mb-4 mt-6 text-black text-md">
        <strong>GURU.com</strong> provides all users with the opportunity to
        opt-out of receiving non-essential (promotional, marketing-related)
        communications from us on behalf of our partners, and from us in
        general, after setting up an account. If you want to remove your contact
        information from all <strong>GURU.com</strong> lists and newsletters,
        please visit <strong>GURU.com</strong>.
      </p>

      {/* Section 7 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        7. Advertisements on Guru Sports  - GURU
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        We may use third-party advertising companies to serve ads when you visit
        our website. These companies may use information (not including your
        name, address, email address, or telephone number) about your visits to
        this and other websites in order to provide advertisements about goods
        and services of interest to you.
      </p>

      {/* Section 8 */}
      <h3 className="text-3xl font-semibold mb-2 mt-8">
        8. Contact our Privacy Department
      </h3>
      <p className="mb-4 mt-6 text-black text-md">
        Should you have any discrepancies or grievances or questions regarding
        this statement or with respect to personal identifiable information
        provided by you, please contact our grievance officer at the following
        address: <strong>info@GURU.com</strong>
      </p>
    </div>
  );
}
